import React, {useEffect} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {withRouter} from 'react-router-dom';
import InputAdornment from '@material-ui/core/InputAdornment';
import {styles} from './FidelityProgram.styles';
import Input from '../Input';
import {cashbackConfigHasError, getCashbackValidationMessage, handleChange} from './FidelityProgram.services';
import {cashbackLoyaltyFormError, CashbackLoyaltyFormInput} from './FidelityProgram.form';
import {isTypingNumber} from '../../utils/formUtils';

type FidelityProgramProps = {
    classes: any;
    setStateObj: (value: any) => void;
    stateObj: {
        enabledCashBack: boolean;
        cashBackPointsPerEuro: string | number;
        limit: string | number;
        minBasket: string | number;
    };
    validationMessage: any;
    setValidationMessage: (value: any) => void;
    setHasCashbackFormError: (value: boolean) => void;
};

const FidelityProgram = ({
                             classes,
                             setStateObj,
                             stateObj,
                             validationMessage,
                             setValidationMessage,
                             setHasCashbackFormError
                         }: FidelityProgramProps) => {

    useEffect(() => {
        const cashbackValidationMessage = getCashbackValidationMessage({
            cashBackPointsPerEuro: stateObj.cashBackPointsPerEuro,
            limit: stateObj.limit,
            minBasket: stateObj.minBasket
        });
        setValidationMessage(cashbackValidationMessage);
        setHasCashbackFormError(cashbackConfigHasError(stateObj, cashbackValidationMessage));
    }, [
        stateObj.cashBackPointsPerEuro,
        stateObj.limit,
        stateObj.minBasket,
        setValidationMessage,
        setHasCashbackFormError
    ]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {id, value} = e.target;
        if (value === '') {
            setStateObj({[id]: ''});
            handleChange(e, validationMessage, setValidationMessage);
            return;
        }
        if (!isTypingNumber(value)) {
            return;
        }
        setStateObj({[id]: value});
        handleChange(e, validationMessage, setValidationMessage);
    };

    const handleMinBasketChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        if (value === '') {
            setStateObj({minBasket: ''});
            return;
        }
        if (!isTypingNumber(value)) {
            return;
        }
        if (Number(value) < 0) {
            setStateObj({minBasket: 0})
            return;
        }
        setStateObj({minBasket: value});
    };

    return (
        <div className={`${classes.paper} ${!stateObj.enabledCashBack && classes.disabledStyle}`}>
            <p className={classes.designText}>Montant de la fidélité</p>
            <Input
                margin='dense'
                id={CashbackLoyaltyFormInput.POINTS_PER_EURO}
                variant='outlined'
                value={stateObj.cashBackPointsPerEuro as string}
                className={classes.inputStyle}
                placeholder='Ex:10'
                error={
                    validationMessage?.[CashbackLoyaltyFormInput.POINTS_PER_EURO]?.text ===
                    cashbackLoyaltyFormError
                }
                helperText={validationMessage?.[CashbackLoyaltyFormInput.POINTS_PER_EURO]?.helperText}
                onChange={handleInputChange}
                onFocus={e => handleChange(e, validationMessage, setValidationMessage)}
                onBlur={e => handleChange(e, validationMessage, setValidationMessage)}
                InputProps={{
                    endAdornment: <InputAdornment position='end'>€</InputAdornment>
                }}
            />

            <p className={classes.designText}>Pour combien d'euros dépensés</p>
            <Input
                margin='dense'
                id={CashbackLoyaltyFormInput.LIMIT}
                variant='outlined'
                value={stateObj.limit as string}
                className={classes.inputStyle}
                placeholder='Ex:100'
                error={
                    validationMessage?.[CashbackLoyaltyFormInput.LIMIT]?.text ===
                    cashbackLoyaltyFormError
                }
                helperText={validationMessage?.[CashbackLoyaltyFormInput.LIMIT]?.helperText}
                onChange={handleInputChange}
                onFocus={e => handleChange(e, validationMessage, setValidationMessage)}
                onBlur={e => handleChange(e, validationMessage, setValidationMessage)}
                InputProps={{
                    endAdornment: <InputAdornment position='end'>€</InputAdornment>
                }}
            />

            <p className={classes.designText}>Valeur minimale du panier</p>
            <Input
                margin='dense'
                id={CashbackLoyaltyFormInput.MIN_BASKET}
                variant='outlined'
                value={stateObj.minBasket as string}
                onChange={handleMinBasketChange}
                error={
                    validationMessage?.[CashbackLoyaltyFormInput.MIN_BASKET]?.text ===
                    cashbackLoyaltyFormError
                }
                helperText={validationMessage?.[CashbackLoyaltyFormInput.MIN_BASKET]?.helperText}
                className={classes.inputStyle}
                placeholder='Ex:15'
                InputProps={{
                    endAdornment: <InputAdornment position='end'>€</InputAdornment>
                }}
            />
        </div>
    );
};

export default withStyles(styles as any)(withRouter(FidelityProgram));